import {Box} from "@mui/material";
import React from "react";

type ImportantTextProps = {
    children: React.ReactNode;
};

const ImportantText: React.FC<ImportantTextProps> = ({children}) => (
    <Box component="b" sx={{color: 'primary.contrastText'}}>
        {children}
    </Box>
);

export default ImportantText;
